import styles from "./menu.module.css";

export default function Menu() {
    return (
        <nav className={styles.nav}>
            <ul className={styles.navList}>
                <li><a href='/#'>Games</a></li>
                <li><a href='/#/subscriptions'>Subscriptions</a></li>
            </ul>
        </nav>
    )
}